import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import PropTypes from "prop-types";

const commonButtonSx = {
    borderRadius: "50%",
    padding: "4px",
};

export const FileActionButton = ({ title, onClick, href, icon, sx }) => (
    <Tooltip title={title}>
        <IconButton
            {...(href ? { component: "a", href, target: "_blank", rel: "noopener noreferrer" } : {})}
            onClick={onClick}
            sx={{ ...sx, ...commonButtonSx }}
        >
            {icon}
        </IconButton>
    </Tooltip>
);

FileActionButton.propTypes = {
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    href: PropTypes.string,
    icon: PropTypes.node.isRequired,
    sx: PropTypes.object,
};